import { contentBase as contentBaseSchema } from './content';
import { metadata } from './helpers';
import { z } from 'zod';

export const caseResultContentSchema = z.object({
  metadata: metadata,
  data: z.object({
    subtitle: z.string(),
    results: z
      .array(
        z.object({
          amount: z.string(),
          claim_type: z.string(),
        })
      )
      .min(1, 'At least one Result is required'),
  }),
});

export const contentTypeCaseResultContentSchema = contentBaseSchema.extend({
  content: caseResultContentSchema,
});

export type ContentTypeCaseResultContentInput = z.infer<typeof contentTypeCaseResultContentSchema>;
